module.exports = __webpack_public_path__ + "img/ticket_icon2.d35c6aa2.svg";